import React from 'react'
import Link from 'gatsby-link'
import { HelmetDatoCms } from 'gatsby-source-datocms'

import Button from '../components/Button'
import Description from '../components/Description'
import Feature from '../components/Feature'
import Gallery from '../components/Gallery'
import Grid from '../components/Grid'
import Hero from '../components/Hero'
import HouseRooms from '../components/HouseRooms'
import HouseTabs from '../components/HouseTabs'
import Map from '../components/Map'

const HomePage = ({ data }) => (
  <div>
    <HelmetDatoCms seo={data.house.seoMetaTags} />
    <Hero house={ data.house } />
    <Gallery house={ data.house } />
    <Description house={ data.house.description } />
    <HouseRooms rooms={ data.house.roomNumbers } />
    <Map location={ data.house.location } />
    <Button locale={ data.house.locale } airbnb={ data.house.airbnb } logo={ data.homepage.airbnbLogo } />
    <HouseTabs house={ data.house.rooms } locale={ data.house.locale } />
    <Feature house={ data.house } />
    <Grid rooms={ data.house.rooms } />
  </div>
)

export default HomePage

export const query = graphql`
  query House($slug: String!, $locale: String!) {
    house: datoCmsHouse(slug: { eq: $slug }, locale: { eq: $locale }) {
      id
      locale
      location {
        latitude
        longitude
      }
      name
      tagLine
      description
      address
      airbnb
      image {
        sizes(maxWidth: 1920) {
          ...GatsbyDatoCmsSizes
        }
      }
      gallery {
        sizes(maxWidth: 1920) {
          ...GatsbyDatoCmsSizes
        }
      }
      roomNumbers {
        id
        number
        room {
          id
          name
        }
      }
      rooms {
        id
        kind {
          name
        }
        description
        gallery {
          sizes(maxWidth: 900) {
            ...GatsbyDatoCmsSizes
          }
        }
      }
      featuresDescription
      featuresPhoto {
        sizes(maxWidth: 800) {
          ...GatsbyDatoCmsSizes
        }
      }
      features {
        id
        title
        content
      }
      seoMetaTags {
        ...GatsbyDatoCmsSeoMetaTags
      }
    }
    homepage:  datoCmsHomepage(locale: { eq: $locale }) {
      airbnbLogo {
        sizes(maxWidth: 400) {
          ...GatsbyDatoCmsSizes
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/templates/house.js